import React from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";

export interface FacebookFormState {
    title: string;
    description: string;
}

interface FacebookFormStateProps {
    onFieldChange: (field: string, value: string | boolean) => void;
    onFieldBlur?: (field: string, value: string | boolean) => void;
    defaultFormState: FacebookFormState;
    disableCompilationFields?: boolean;
}

const FacebookForm: React.FC<FacebookFormStateProps> = ({
                                                            onFieldChange,
                                                            onFieldBlur, // Destrutturiamo la nuova prop
                                                            defaultFormState,
                                                            disableCompilationFields = false
                                                        }) => {

    const handleBlur = (field: string, value: string | boolean) => {
        if (onFieldBlur) {
            onFieldBlur(field, value);
        }
    };

    return (
        <Grid container spacing={2}>
            <Grid size={{ md: 12, lg: 12 }}>
                <Box display="flex" flexDirection={'column'}>
                    <TextField
                        value={defaultFormState.title}
                        name={"facebookTitle"}
                        placeholder={"Insert post title"}
                        type={'text'}
                        variant={'outlined'}
                        onChange={(e) => onFieldChange('title', e.target.value)}
                        onBlur={(e) => handleBlur('title', e.target.value)}
                        fullWidth
                        sx={{ mb: 2 }}
                        disabled={disableCompilationFields}
                    />
                    <TextField
                        multiline
                        minRows={6}
                        placeholder={'Type post description'}
                        label={'Description'}
                        value={defaultFormState.description}
                        onChange={(e) => onFieldChange('description', e.target.value)}
                        onBlur={(e) => handleBlur('description', e.target.value)}
                        fullWidth
                        sx={{ height: '100%', display: 'flex' }}
                        disabled={disableCompilationFields}
                    />
                </Box>
            </Grid>
        </Grid>
    )
}

export default FacebookForm;